export default __webpack_public_path__ + "static/media/thinking.86d8f689.jpg";